import type { ColorMap } from './types';

export const TEST_ID = 'droneHealthChart';

export const LOW_THRESHOLD = 0;

export const MEDIUM_THRESHOLD = 15;

export const HIGH_THRESHOLD = 50;

export const COLOR_MAP: ColorMap = {
    [HIGH_THRESHOLD]: 'var(--drone-health-chart-high-color)',
    [LOW_THRESHOLD]: 'var(--drone-health-chart-low-color)',
    [MEDIUM_THRESHOLD]: 'var(--drone-health-chart-medium-color)'
};
